<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<!-- <app-footer></app-footer> -->

@if(isPublicClinicPage){
<router-outlet></router-outlet>
}
@else{
@if(isMobile){
@if(tokenExists){
<app-header-mobile></app-header-mobile>
}
@else{
<app-notuserheader-m></app-notuserheader-m>

}
<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->

<!-- FLOATING BUTTON AFTER CLOSE -->
<button
  type="button"
  class="pwa-floating-btn"
  *ngIf="showInstallButton && isMobile && !installPopupOpen"
  (click)="openInstallPopup()"
>
  <i class="fa-solid fa-mobile-screen-button"></i>
</button>
}
@else{
@if(tokenExists){
<div class="layout">

  <!-- Mobile Header -->
  <app-header-mobile *ngIf="isMobile"></app-header-mobile>

  <!-- SIDEBAR -->
  <aside class="sidebar noPrint" [class.closed]="sidebarClosed">

    <!-- Logo -->
    <div class="sidebar-logo">
      <img [src]="(warehouseImage$ | async) || '/assets/logo-01.png'" />

      <div class="sidebar-warehouse-title">
        <p>{{ warehouseName$ | async }}</p>

        @if (warehouseType$ | async; as warehouseType) {
        <span class="bb-badge sidebar-warehouse-type" [ngClass]="warehouseTypeBadgeClass(warehouseType)">
          <i [ngClass]="warehouseTypeIcon(warehouseType)" aria-hidden="true"></i>
          {{ warehouseTypeLabel(warehouseType) | transloco }}
        </span>
        }
      </div>
    </div>

    <!-- Desktop Header -->
    <app-header *ngIf="!isMobile"></app-header>



  </aside>

  <!-- MAIN CONTENT -->
  <div class="content">

    <!-- Sidebar Toggle -->
    <button class="toggle-btn noPrint" type="button" (click)="toggleSidebar()">
      <span class="logo-color-burger" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>

    <router-outlet></router-outlet>
  </div>

</div>
}
@else{
<app-notuserheader></app-notuserheader>
<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<router-outlet></router-outlet>
}
}
}

<!-- PWA INSTALL POPUP -->
<div
  class="pwa-install-backdrop"
  *ngIf="showInstallButton && isMobile && installPopupOpen"
>
  <div class="pwa-install-popup">

    <button
      type="button"
      class="pwa-popup-close"
      (click)="closeInstallPopup()"
    >
      ×
    </button>

    <div class="pwa-mobile-icon">
      <i class="fa-solid fa-mobile-screen-button"></i>
    </div>

    <h3>{{ "Add to Home Screen" | transloco }}</h3>

    <p>
      {{ "Install the app on your mobile for faster access" | transloco }}
    </p>

    <button
      type="button"
      class="pwa-install-action"
      (click)="installPWA()"
    >
      {{ "Add to Home Screen" | transloco }}
    </button>

  </div>
</div>
